import { AmountField } from '@ovComponents/3-pattern/amountField/amountField';
import { FieldRequiredType } from '@ovComponents/4-module/configurableOptionFields/basicField';
import { toAmountCents } from '@ovComponents/4-module/workflowCompletion/subSteps/utils/depositAmountRules';
import type { CurrencyBalance } from '@ovComponents/4-module/workflowCompletion/subSteps/utils/depositCurrencies';
import type { TransferContextData } from '@ovComponents/4-module/workflowCompletion/workflowTypes';
import { useLocalization } from '../../../../../../hooks/useLocalization';
import { DepositInternalTransferCurrencyBalanceDisplay } from './DepositInternalTransferCurrencyBalanceDisplay';

type AmountFieldOption = {
  required?: FieldRequiredType;
  label?: unknown;
};

export type DepositInternalTransferAmountProp = {
  deposit: TransferContextData;
  options: { amountCents?: AmountFieldOption };
  focused: string[];
  onFocus: (field: string) => void;
  onChange: (value: Partial<TransferContextData>) => void;
  amountError: { hasError: boolean; errorMessage: string };
  enableMultiCurrencyDepositTransfers: boolean;
  currencyBalance: CurrencyBalance | null;
};

export const DepositInternalTransferAmount = ({
  deposit,
  options,
  focused,
  onFocus,
  onChange,
  amountError,
  enableMultiCurrencyDepositTransfers,
  currencyBalance,
}: DepositInternalTransferAmountProp) => {
  const { translateBackendString } = useLocalization();

  return (
    <>
      <AmountField
        useFormatAmountValueCents
        sx={{ mb: 1 }}
        testId='deposit-form-amount-cents'
        label={translateBackendString(options?.amountCents?.label)}
        setAmount={(e: any) =>
          onChange({
            amountCents: toAmountCents(e),
          })
        }
        amount={deposit?.amountCents}
        onBlur={() => onFocus('amountCents')}
        error={
          (!deposit?.amountCents &&
            focused.includes('amountCents') &&
            options?.amountCents?.required !==
              FieldRequiredType.NOT_REQUIRED) ||
          (amountError.hasError && focused.includes('amountCents'))
        }
        errorText={amountError.hasError ? amountError.errorMessage : undefined}
        {...(enableMultiCurrencyDepositTransfers && deposit?.currency
          ? { currency: deposit.currency }
          : {})}
      />
      {enableMultiCurrencyDepositTransfers &&
        deposit?.currency &&
        currencyBalance && (
          <DepositInternalTransferCurrencyBalanceDisplay
            amountCents={deposit?.amountCents}
            currencyBalance={currencyBalance}
          />
        )}
    </>
  );
};
